export const islandsMapTranslations = {
  en: {
    pageTitle: 'Biosphere Reserves',
    backToList: 'Back to list',
    legendTitle: 'Legend',
    poMuseums: 'Po Museums',
    naturalAreas: 'Natural Areas',
    legend: 'Legend of Protected Natural Areas\nNatura 2000 Network',
    museumInfo: 'In this section you can find a first network of museum knowledge about the Po, highlighting and enhancing the various forms in which the river is associated with human presence, through tradition, history, memory, naturalistic component, art.',
    naturalAreasInfo: 'Natural areas include islands, oxbow lakes and river branches, riparian forests, areas characteristic of the typical natural components of the Po River. Among these, there are protected and restricted natural areas, recognized within Natura 2000, the network of sites of community importance and special protection zones created by the European Union for the conservation of important habitats and species.',
    loading: 'Loading Islands...',
    noIslandsMemory: 'No ecological island information in memory - restart the app and try again',
    islandsError: 'Problem receiving ecological island data - restart the app and try again',
    errorHeader: 'Data retrieval error',
    errorMessage: 'There was a problem retrieving the dock data! Please restart the app and try again.',
    okButton: 'Ok',
    visitMuseum: 'Visit museum website',
    welcomeMAB: 'Welcome to UNESCO MAB Reserve',
    goodbyeMAB: 'Goodbye from UNESCO MAB Reserve',
    andWelcome: 'and welcome to UNESCO MAB Reserve'
  },
  it: {
    pageTitle: 'Riserve della Biosfera',
    backToList: 'Torna alla lista',
    legendTitle: 'Legenda',
    poMuseums: 'Musei del Po',
    naturalAreas: 'Aree naturalistiche',
    legend: 'Legenda Aree naturali protette\nRete Natura 2000',
    museumInfo: 'In questa sezione si può trovare una prima rete di conoscenza museale sul Po, in cui esaltare e valorizzare le varie forme con le quali il fiume è associato alla presenza dell\'uomo, per tradizione, storia, memoria, componente naturalistica, arte.',
    naturalAreasInfo: 'Le aree naturalstiche comprendono isole, lanche e rami fluviali, foreste ripariali, zone caratteristiche per le compenenti naturali tipiche del fiume Po. Tra queste, ci sono aree naturali protette e vincolate, riconosciute all\'interno di Rete Natura 2000, la rete di siti di interesse comunitario e zone di protezione speciale creati dall\'Unione Europea per conservazione di habitat e specie riconosciuti come prioritari.',
    loading: 'Caricamento Isole...',
    noIslandsMemory: 'Non sono presenti informazioni sulle isole ecologiche in memoria - riavviare l\'app e riprovare',
    islandsError: 'Problema nella ricezione dei dati sulle isole ecologiche - riavviare l\'app e riprovare',
    errorHeader: 'Errore di recupero dati',
    errorMessage: 'C\'è stato un problema nel recupero dei dati sugli attracchi! Per favore riavvia l\'app e riprova.',
    okButton: 'Ok',
    visitMuseum: 'Visita il sito del museo',
    welcomeMAB: 'Benvenuto nella Riserva MAB UNESCO',
    goodbyeMAB: 'Arrivederci dalla Riserva MAB UNESCO',
    andWelcome: 'e benvenuto nella Riserva MAB UNESCO'
  }
}; 